"use client";
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";

const queryClientOptions = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      staleTime: 5 * 1000,
      retry: false,
      
    },
  },
};

const QueryProvider = ({ children }) => {
  const [mutationCache] = useState(
    new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.options.onError) return;
        enqueueSnackbar(error.response?.data?.message, {
          variant: "error",
        });
      },
    })
  );

  const [queryClient] = useState(
    new QueryClient({
      mutationCache,
      ...queryClientOptions,
    })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default QueryProvider;
